import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lovi_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // FormData uploads must let the browser set 'multipart/form-data; boundary=...'
  // itself — the default 'application/json' header on this instance would
  // otherwise override it and the backend would never see the file field.
  if (config.data instanceof FormData && config.headers) {
    delete config.headers['Content-Type'];
  }
  return config;
});

// Endpoints whose 401 is a business-rule failure (e.g. wrong current
// password), NOT an invalid/expired session — must never force a logout.
const AUTH_401_EXEMPT_PATHS = ['/auth/change-password', '/auth/login'];

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error?.config?.url || '';
    const isExempt = AUTH_401_EXEMPT_PATHS.some((p) => url.includes(p));
    if (error?.response?.status === 401 && !isExempt) {
      localStorage.removeItem('lovi_token');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
